import React from 'react';
import { get, isEmpty } from 'lodash';

// React view component to render
import { cSrMemberNotes as CSrMemberNotesView } from 'ui/views/widgets/cSRMemberNotes';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import { MemberDetailAssistiveActionsNavWidgetService } from 'services/memberDetailAssistiveActionsNavWidget';
import * as errorOverlay from 'utils/errorOverlay';
import { SERVICE_RESPONSE_STATUS, SIZES } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CsrMemberNotes } from 'ui/containers/CSRMemberNotes';
 *
 * // render
 * <CsrMemberNotes propName='propValue'/>
 */
export class CsrMemberNotes extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isAdd: false,
            data: this.props.data
        };

        // create service instance
        this.memberDetailAssistiveActionsNavWidgetService = new MemberDetailAssistiveActionsNavWidgetService();

        this.handleSubmitClick = this.handleSubmitClick.bind( this );
        this.updateNotesView = this.updateNotesView.bind( this );
    }

    async handleSubmitClick( value ) {
        log.debug( 'CsrMemberNotes.handleSubmitClick()' );

        // find action with `name: submit`
        const action = get( this.props, 'action' );

        // cancel ongoing request
        this.memberDetailAssistiveActionsNavWidgetService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // get status and service data
        const { _status, resData } = await this.memberDetailAssistiveActionsNavWidgetService.addNotes( {
            url: action.url,
            data: {
                ...this.props.requestPayload,
                data: {
                    ...value
                }
            }
        } );

        if( SERVICE_RESPONSE_STATUS.SUCCESS === _status ) {

            this.fetchNotesData();
            
        } else {

            // show page level preloader
            pageLevelPreloader.hide();

            if( ! isEmpty( get( resData, 'description' ) ) ) {
                errorOverlay.open( { message: resData.description, size: SIZES.SMALL, } );
            } else {
                errorOverlay.open();
            }
        }
    }

    async fetchNotesData() {
        log.debug( 'CsrMemberNotes.fetchNotesData()' );

        // cancel ongoing request
        this.memberDetailAssistiveActionsNavWidgetService.cancel();

        // get status and service data
        const { status, data } = await this.memberDetailAssistiveActionsNavWidgetService.epostMSRNotes( {
            url: this.props.url,
            data: this.props.requestPayload
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            this.setState( { data: data, isAdd: false } );

        } else {

            if( ! isEmpty( get( data, 'description' ) ) ) {
                errorOverlay.open( { message: data.description, size: SIZES.SMALL, } );
            } else {
                errorOverlay.open();
            }
        }


    }

    updateNotesView( value ) {
        log.debug( 'CsrMemberNotes.updateNotesView()' );
        
        this.setState( { isAdd: value } );

    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CSrMemberNotesView
                { ...this.props }
                onSubmitClick={ this.handleSubmitClick }
                setAdd={ this.updateNotesView }
                { ...this.state }
            />
        );
    }
}

// set display name
CsrMemberNotes.displayName = 'CsrMemberNotes';

// set default props
CsrMemberNotes.defaultProps = {};

// prop types
CsrMemberNotes.propTypes = {};
